module.exports = __webpack_public_path__ + "static/img/kyzkTitle.02f6f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kyzkTitle.png
// module id = +7KF
// module chunks = 2